'use strict';

import axios from "axios";
import {cardsData, isMobile, settingsData} from "../../settings";
import {CardTypes} from "../../common";
import {createElements} from "../../functions";
import { changeLangToCurrent, getCurrentLangDirection, isDesktopMode } from '../language/langSwitcher';
import gsap from "gsap";
import Notiflix from 'notiflix';

Notiflix.Notify.init({
    width:'100%',
    timeout:10000,
    messageMaxLength:1000,
    zindex:100,
    opacity:1,
    position:'right-top',
    clickToClose: true,
    pauseOnHover: true,
    cssAnimation: true,
    cssAnimationDuration: 500,
    cssAnimationStyle: 'from-top',
    plainText: false,
    ID: 'notiflix',
    info:{
        background: '#519af8',
        notiflixIconColor: 'rgba(255,255,255,1)'
    }
});

export function changeNotiflixNotifyPosition () {
    const dir = getCurrentLangDirection();
    const notiflix = document.querySelector('#NotiflixNotifyWrap');

    if (!notiflix){
        return;
    }

    Notiflix.Notify.merge({
        position: isDesktopMode() ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
        rtl: (dir !== 'ltr')
    });

    for (let info of notiflix.children){
        if (dir === 'rtl'){
           info.classList.add('nx-rtl-on')
        } else {
           info.classList.remove('nx-rtl-on')
        }
    }

    notiflix.style.inset = dir === 'rtl' ? '10px auto auto 10px' : '10px 10px auto auto';
}

export function closeNotifications () {
    const notiflix = document.querySelector('#NotiflixNotifyWrap');
    if (!notiflix){
        return;
    }

    notiflix.remove();
}

const optionsStatistic = {
    propertyId: config.features.googleAnalytics?.propertyId,
    types: ['card-view', 'favorites']
}

const setRandomValues = (type) => {
    return settingsData.allCrmData.map(data => {
        return {
            eventType: type,
            bmbyPropId: data.bmbyPropID,
            propNum: data.propNum,
            count: Math.floor(Math.random() * 100 / 2)
        }
    });
}

export const getGoogleAnalyticsData = async () => {
    if (!config.features.googleAnalytics?.active || config.features.googleAnalytics?.notification?.length === 0) return;
    console.warn('GET DATA FROM GA');

    const {protocol, host} = location;


    for (let type of optionsStatistic.types){
        const requestURL = `${protocol}//${host}/?analytics=${type}&id=${optionsStatistic.propertyId}`;
        const response = await axios.get(requestURL);
        settingsData.statisticData[type] = response.data;
    }


    // optionsStatistic.types.forEach(type => {
    //     const requestURL = `${protocol}//${host}/?analytics=${type}&id=${optionsStatistic.propertyId}`;
    //     const data = axios.get(requestURL);
    //     console.log(data);
    //
    //     // settingsData.statisticData[type] = setRandomValues(type);
    // });
}

export const createPopUp = () => {
    // const parent = document.querySelector(`.${CardTypes.Options}-card__plans-box`);
    const statisticBlock = createElements('div', [`${CardTypes.Options}-card__statistic-container`]);
    //
    // const iconBox = createElements('div', [`${CardTypes.Options}-card__statistic-container-icon-box`, 'icon-light-bulb--tick'], statisticBlock);
    // const textBox = createElements('div', [`${CardTypes.Options}-card__statistic-container-text-box`], statisticBlock);

    const statisticInterestedBlock = createElements('div', [`${CardTypes.Options}-card__statistic-container-stat-box`]);
    const statisticFavoritesBlock = createElements('div', [`${CardTypes.Options}-card__statistic-container-stat-box`]);

    const statInterestedText = createElements('span', [`${CardTypes.Options}-card__statistic-container_interest`, 'language-string'], statisticInterestedBlock, 'beforeend', {
        data: 'data-dictionary',
        value: 'statInterestedText',
    });

    const statFavoritesText = createElements('span', [`${CardTypes.Options}-card__statistic-container_favorites`, 'language-string'], statisticFavoritesBlock, 'beforeend', {
        data: 'data-dictionary',
        value: 'statFavoritesText',
    });

    statInterestedText.innerHTML = changeLangToCurrent('statInterestedText');
    statFavoritesText.innerHTML = changeLangToCurrent('statFavoritesText');

    // createElements('button', [`${CardTypes.Options}-card__statistic-container-close-btn`, 'icon-close'], statisticBlock);
    //
    //
    // statisticBlock.addEventListener('click', closeStatistic);
    //
    // setTimeout(closeStatistic, 10 * 1000);

    return {
        statisticBlock,
        statisticInterestedBlock,
        statisticFavoritesBlock
    }
}

export const showStatisticPopUp = (object) => {
    if (isMobile || cardsData.cardMode.isAmenities || cardsData.cardMode.isUnavailable) return;

    const optionCard = document.querySelector(`.${CardTypes.Options}-card`);
    if (!optionCard){
        return;
    }

    const {statisticData} = settingsData;
    const popUpArray = [];

    if (!Object.keys(statisticData).length){
        return;
    }

    const notifications = config.features.googleAnalytics.notification;

    const dir = getCurrentLangDirection();

    Notiflix.Notify.merge({
        position: isDesktopMode() ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
        rtl: (dir !== 'ltr')
    });

    const cardView = Array.isArray(statisticData['card-view']) && notifications?.find(notification => notification.type === 'card-view' && notification.active) ? statisticData['card-view'].find(data => Number(data.bmbyPropId) === object.bmbyPropID) : undefined;

    const favorites = Array.isArray(statisticData['favorites']) && notifications?.find(notification => notification.type === 'favorites' && notification.active) ? statisticData['favorites'].find(data => Number(data.bmbyPropId) === object.bmbyPropID) : undefined;

    const {statisticInterestedBlock, statisticFavoritesBlock, statisticBlock} = createPopUp();

    if (cardView){
        statisticInterestedBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${cardView.count}</span>`);
        const copyInterested = statisticBlock.cloneNode(true);
        copyInterested.appendChild(statisticInterestedBlock);
        popUpArray.push(copyInterested);
    }

    if (favorites){
        statisticFavoritesBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${favorites.count}</span>`);
        const copyFavorite = statisticBlock.cloneNode(true);
        copyFavorite.appendChild(statisticFavoritesBlock);
        popUpArray.push(copyFavorite);
    }

    popUpArray.forEach((popup,index) =>{
        setTimeout(()=> {
            if (document.querySelector(`.${CardTypes.Options}-card`)){
                Notiflix.Notify.info(`${popup.innerHTML}`)
            }
        },index * 1000);
    });
}

// const closeStatistic = () => {
//     const statisticBlock = document.querySelector(`.${CardTypes.Options}-card__statistic-container`);
//
//     if (!statisticBlock) return;
//
//     gsap.to(statisticBlock, {
//         transform: 'translateY(-120%)',
//         autoAlpha: 0,
//         duration: .5,
//         onComplete: () => {
//             statisticBlock.removeEventListener('click', closeStatistic);
//             statisticBlock.remove();
//         },
//     })
// }
